import React, { useCallback, useContext, useState } from "react";
import { Box, Flex, Icon, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Text, useTranslation } from "@familyzone/component-library";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { zIndices } from "../../utils/ZIndexUtil";
import DropDownDeviceVersion from "./DeviceVersion";
import DropDownDeviceAlerts from "./DeviceAlerts";
import DiagnosticToolsModal from "../modals/DiagnosticToolsModal";
import DeviceFilteringModal from "./DeviceFilteringModal";
import { useSessionStore } from "../../storez/SessionStore";
import RestartApplianceModal from "../modals/RestartApplianceModal";
import { ReactRouterCompatContext } from "../ContextProvider";
import { InjectedRouter } from "react-router";

const DeviceMenu: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useContext(ReactRouterCompatContext) as { router: InjectedRouter };
  const [device] = useSessionStore(useCallback((state) => [state.device] as const, []));
  const [toolsOpen, setToolsOpen] = useState(false);
  const [restartOpen, setRestartOpen] = useState(false);
  const [filteringModalOpen, setFilteringModalOpen] = useState(false);

  const openDeviceOptions = () => {
    router.push("/managedevice");
  };

  const openDeviceUpdate = () => {
    router.push("/managedevice/settings/updates");
  };

  const openDiagnostics = () => {
    router.push("/managedevice/settings/diagnostics");
  };

  const openAlarms = () => {
    router.push("/managedevice/settings/diagnostics/alarms");
  };

  const openDevicePermissions = () => {
    router.push("/managedevice/settings/permissions");
  };

  const openDevices = () => {
    router.push("/devices");
  };

  return (
    <>
      <Box marginRight="10px">
        <Menu>
          <MenuButton width="5px" padding="9px 16px" aria-label={t("Device Menu")}>
            <Flex justifyContent="center">
              <Icon icon="fa-ellipsis-vertical" height="18px" width="18px" boxSize="18px" />
            </Flex>
          </MenuButton>
          <MenuList zIndex={zIndices.menu}>
            <AuthorizationWrapper allowedRoles={["owner"]}>
              <MenuGroup title="Owner Tools">
                <MenuItem onClick={() => setToolsOpen(true)}>{t("Tools")}</MenuItem>
                <MenuItem onClick={() => setFilteringModalOpen(true)}>
                  Turn Off Filtering Temporarily
                  <DeviceFilteringModal modalOpen={filteringModalOpen} setModalOpen={setFilteringModalOpen} />
                </MenuItem>
                <MenuItem onClick={openDevicePermissions}>{t("Permissions")}</MenuItem>
                <MenuItem onClick={openDeviceOptions}>{t("Device Options")}</MenuItem>
                <MenuItem onClick={openDiagnostics}>{t("Diagnostics")}</MenuItem>
                <MenuItem onClick={() => setRestartOpen(true)}>{t("Restart")}</MenuItem>
              </MenuGroup>
            </AuthorizationWrapper>
            <MenuGroup title="Device">
              <MenuItem onClick={openDevices}>{t("Switch Device")}</MenuItem>
            </MenuGroup>
          </MenuList>
        </Menu>
      </Box>
      <Box marginRight="15px">
        <Text color="neutrals.900" fontWeight="bold">
          {device?.name && String(device.name) !== "null" ? device.name : "Linewize Filter"}
        </Text>
        <Text color="neutrals.400" fontSize="sm">
          {device?.id}
        </Text>
      </Box>
      <Flex alignItems="center">
        <DropDownDeviceVersion allowedRoles={["owner"]} onClick={openDeviceUpdate} />
        <DropDownDeviceAlerts allowedRoles={["owner"]} onClick={openAlarms} />
      </Flex>
      <RestartApplianceModal isOpen={restartOpen} onClose={() => setRestartOpen(false)} />
      <DiagnosticToolsModal isOpen={toolsOpen} onClose={() => setToolsOpen(false)} />
    </>
  );
};

export default DeviceMenu;
